export default __webpack_public_path__ + "static/media/bg.99c55bde.png";